// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gp-1";
export var messageSideRight = "_gp-2";
export var subscribeToBackInStockBubbleContainer = "_gp-0";